import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Group.module.css';

const gapMap = {
  xs: 'var(--wp-space-8)',
  sm: 'var(--wp-space-12)',
  md: 'var(--wp-space-16)',
  lg: 'var(--wp-space-24)',
  xl: 'var(--wp-space-32)',
} as const;

export type GroupGap = keyof typeof gapMap;

export type GroupProps = HTMLAttributes<HTMLDivElement> & {
  gap?: GroupGap | string | number;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  wrap?: CSSProperties['flexWrap'];
  grow?: boolean;
  children: ReactNode;
};

function gapToCss(gap: GroupProps['gap']): string | undefined {
  if (gap == null) return gapMap.md;
  if (typeof gap === 'number') return `${gap}px`;
  if (gap in gapMap) return gapMap[gap as GroupGap];
  return String(gap);
}

export function Group({
  gap = 'md',
  align,
  justify,
  wrap = 'wrap',
  grow,
  className,
  style,
  children,
  ...rest
}: GroupProps) {
  return (
    <div
      className={cx(styles.group, grow && styles.grow, className)}
      style={{
        gap: gapToCss(gap),
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
